import * as url from "../url_helper";

import { post } from "../api_helper";

export const getPlantList = data => post(url.GET_PLANTS_LIST, data);